import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import useFeatureFlagStore from '../../store/featureFlagStore';

const LoginForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, isLoading, error } = useAuthStore();
  const { initializeWithUser } = useFeatureFlagStore();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await login(email, password);
      // Initialize feature flags after successful login
      initializeWithUser();
      
      // Get the user's landing page preference, default to dashboard
      const user = useAuthStore.getState().user;
      const landingPage = user?.landing_page || '/dashboard';
      navigate(landingPage);
    } catch (error) {
      // Error is handled by the store
    }
  };

  return (
    <div className="login-form">
      <div className="logo-container">
        <div className="logo-badge">
          <span className="logo-icon"></span>
                          <span className="logo-text">Lumina AI</span>
        </div>
        <p className="logo-tagline">Deep dive into your data</p>
      </div>
      
      <h2>Sign In to Your Account</h2>
      <form onSubmit={handleSubmit}>
        {error && <div className="error-message">{error}</div>}
        
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
          />
        </div>
        
        <div className="form-actions">
          <button type="submit" disabled={isLoading}>
            {isLoading ? 'Starting Engine...' : 'Sign In'}
          </button>
          
          <div className="form-links">
            <button 
              type="button" 
              className="link-button"
              onClick={() => navigate('/reset-password')}
            >
              Forgot password?
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default LoginForm; 